import { UserRole } from '../enums';
import { isReservedUsername, normalizeUsername } from './username';

/**
 * Whether a user may appear on public social surfaces (`/u/{username}`, vanity `/{username}`).
 * Platform admins never expose a public profile. Reserved handles must not power public URLs
 * even if a grandfathered DB row still holds the string.
 */
export function canExposePublicSocialProfile(input: {
  role: UserRole | string;
  username?: string | null;
}): boolean {
  const role = String(input.role ?? '').toLowerCase();
  if (role === UserRole.ADMIN || role === 'admin') {
    return false;
  }

  const username = input.username ? normalizeUsername(input.username) : '';
  if (username && isReservedUsername(username)) {
    return false;
  }

  return true;
}
